export default {
  header: 'We konden je bestelling niet laden',
  text: 'Er is iets misgegaan bij het voorbereiden van je bestelling. Je winkelmandje is veilig — probeer het opnieuw.',
  retry: 'Probeer opnieuw',
  address_header: 'We hebben je bezorgadres nodig',
  address_text: 'We kunnen je totaal pas berekenen als we weten waar we moeten bezorgen. Je winkelmand is veilig.',
  address_action: 'Bezorgadres toevoegen',
  back_checkout: 'Terug naar je bestelling',
  back_basket: 'Terug naar je winkelmand',
};
